import agent from './common'
/**
 * 根据公司Id查询
 * @param {*} params 
 */
const GetByCompId = (params) => {
    let p = {
        url: '/api/product/GetByCompId',
        method:'post',
        ...params
    }
    //console.error('GetByCompId----',params)
    return agent.request(p)
}
/**
 * 根据代理Id分页查询
 * @param {*} params 
 */
const GetByAgent=(params)=>{
    let p={
        url:'/api/product/GetByAgent',
        method:'post',
        ...params
    }
    return agent.request(p)
}
const GetOne=(params)=>{
    return agent.request({
        url:'/api/product/',
        method:'get',
        ...params
    })
}
/**
 * 添加
 * @param {*} params 
 */
const Add=(params)=>{
    let p = {
        url: '/api/product',
        method:'post',
        ...params
    }
    return agent.request(p)
}
/**
 * 编辑
 * @param {*} params 
 */
const Edit=(params)=>{
    let p = {
        url: '/api/product',
        method:'put',
        ...params
    }
    return agent.request(p)
}
/**
 * 删除
 * @param {*} params 
 */
const Remove=(params)=>{
    let p = {
        url: '/api/product',
        method:'delete',
        ...params
    }
    return agent.request(p)
}
/**
 * 屏蔽
 * @param {*} params 
 */
const SetShow=(params)=>{
    let p={
        url:'/api/product/SetShow',
        method:'put',
        ...params
    }
    agent.request(p)
}
/**
 * 设置置顶方式
 * @param {*} params 
 */
const SetTopic=(params)=>{
    let p={
        url:'/api/product/SetTopic',
        method:'put',
        ...params
    }
    agent.request(p)
}

export default {
    GetByCompId,
    GetOne,
    Add,
    Edit,
    Remove,
    SetShow,
    SetTopic,
    GetByAgent
}